import { Search } from "@mui/icons-material";
import { InputAdornment } from "@mui/material";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";

export function SearchBox({ width, placeholder, onChange, sort, borderColor, ...rest }) {
  return (
   <MDBox bgColor={borderColor} p={.2}   sx={{ borderRadius: "20px", }} mr={.5}>
     <MDBox
      // p={1}
      // mr={1}
      display="flex"
      alignItems="center"
      px={1}
      height={35}
      width={width}
      bgColor="transparent"
      sx={{
        borderRadius: "17px",
        backgroundColor: "var(--app-field-bg)",
        border: "1px solid var(--app-border)",
      }}
    >
      <MDInput
        variant="standard"
        placeholder={placeholder}
        fullWidth
        onChange={(e) => {
          onChange(e.target.value);
        }}
        {...rest}
        sx={{
          "& .MuiInputBase-input": {
            color: "var(--app-field-text)",
            WebkitTextFillColor: "var(--app-field-text)",
          },
          "& .MuiInputBase-input::placeholder": {
            color: "var(--app-field-placeholder)",
            opacity: 1,
          },
          "& .MuiInputAdornment-root, & .MuiSvgIcon-root": {
            color: "var(--app-icon-color)",
          },
        }}
        InputProps={{
          disableUnderline: true,
          startAdornment: (
            <InputAdornment position="start">
              <Search />
            </InputAdornment>
          ),
        }}
      ></MDInput>
      {sort}
    </MDBox>
   </MDBox>
  );
}
